import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import BooksSubmitButton from '../../../../components/books/common/buttons/BooksSubmitButton';
import BooksLabeledContainer from '../../../../components/books/model1/BooksLabeledContainer';
import BooksTextInput, {
  TextInputType,
} from '../../../../components/books/model1/forms/BooksTextInput';
import BooksCenteringUnderLineMessage from '../../../../components/books/model1/texts/BooksCenteringUnderLineMessage';
import * as IAuths from '../../../../domain/entities/Auth';
import { CreateUserWithResvQuery } from '../../../../infrastructure/repositories/AuthRepository';
import * as $ from './helper';
import ErrorMessage from './InputCreateUserErrorMessage';

interface Props {
  postable: boolean;
  reservationId: number;
  errors?: IAuths.ErrorType[];
  email: string;
  onSubmit: (query: CreateUserWithResvQuery) => void;
}

interface Control {
  submittable?: boolean;
}

interface State {
  email: string;
  password: string;
  control: Control;
}

class InputCompletionCreateUser extends React.Component<
  Props & InjectedIntlProps,
  State
> {
  constructor(props: Props & InjectedIntlProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    const _state: State = {
      email: this.props.email,
      password: '',
      control: {},
    };
    this.state = {
      ..._state,
      control: this.createControl(_state),
    };
  }

  private createControl(state: State): Control {
    const { control } = state;
    control.submittable = $.getValueByNestedString(state, 'password');
    return control;
  }

  private handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const {
      currentTarget: { name, value },
    } = e;
    const changedState = $.changeObjectByNestedString(this.state, name, value);
    this.setState({
      ...changedState,
      control: this.createControl(changedState as State),
    });
  }

  private async handleSubmit() {
    const { reservationId } = this.props;
    const { password } = this.state;
    if (!reservationId) {
      return;
    }
    this.props.onSubmit({ reservationId, password });
  }

  public render() {
    const { postable, intl, errors } = this.props;
    const {
      control: { submittable },
    } = this.state;
    return (
      <div>
        <BooksCenteringUnderLineMessage>
          {intl.formatMessage({
            id: 'books.formsLabel.createUserSuggest',
          })}
        </BooksCenteringUnderLineMessage>
        <BooksLabeledContainer
          label={intl.formatMessage({
            id: 'books.formsLabel.email',
          })}
        >
          <BooksTextInput
            type={TextInputType.Email}
            name={'email'}
            value={this.state.email}
            disabled={true}
            setValue={true}
            onChange={this.handleChange}
          />
        </BooksLabeledContainer>
        <BooksLabeledContainer
          label={intl.formatMessage({
            id: 'books.formsLabel.password',
          })}
        >
          <BooksTextInput
            type={TextInputType.Password}
            name={'password'}
            value={this.state.password}
            onChange={this.handleChange}
            placeholder={intl.formatMessage({
              id: 'books.formsLabel.passwordPlaceholder',
            })}
          />
        </BooksLabeledContainer>
        <ErrorMessage errors={errors} />
        <BooksSubmitButton
          type="button"
          onClick={this.handleSubmit}
          value={intl.formatMessage({ id: 'books.submitLabel.userResist' })}
          disabled={!submittable || !postable}
          postable={postable}
        >
          {intl.formatMessage({ id: 'books.submitLabel.userResist' })}
        </BooksSubmitButton>
      </div>
    );
  }
}

export default injectIntl(InputCompletionCreateUser);
